import React, { useState } from "react";
import { Button, Tabs, message } from "antd";
import { NextButton, PreviousButton } from "@comps/components";
import IndexLendCategory from "@mods/lendManagement/settings/lendCategories/IndexLendCategory";
import IndexLendType from "@mods/lendManagement/settings/lendTypes/IndexLendType";
import ReadinessSummary from "./ReadinessSummary";

// Step 6 — Loan & Advance Settings. Reuses the real lend-module settings screens:
//   • Loan Categories -> IndexLendCategory (create/view/update/delete)
//   • Loan Types      -> IndexLendType (create/view/update/delete)
// Optional/skippable step: Continue is always enabled.

const StepLoanSettings = (props) => {
  const { onNext, onBack, readiness, readinessLoading, refreshReadiness, statuses, skipStep, clearSkip } = props;
  const [activeTab, setActiveTab] = useState("categories");

  const continueStep = () => {
    clearSkip?.("loans");
    refreshReadiness?.();
    onNext();
  };

  const skip = () => {
    skipStep?.("loans");
    message.info("Loans and advances skipped for now.");
    onNext();
  };

  const items = [
    {
      key: "categories",
      label: "Loan Categories",
      children: (
        <div className="onb-embed">
          <div className="onb-card-sub">
            Group your loans and advances into categories (e.g. Salary Advance, Vehicle, Emergency) — create, view and edit them here.
          </div>
          <IndexLendCategory modkey="lendCategories" />
        </div>
      ),
    },
    {
      key: "types",
      label: "Loan Types",
      children: (
        <div className="onb-embed">
          <div className="onb-card-sub">
            Define the loan / advance types employees can request, with their eligibility and gap rules.
          </div>
          <IndexLendType modkey="lendTypes" />
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="onb-card-title">Loan &amp; advance settings</div>
      <div className="onb-card-sub">
        Optional: configure loan and advance setup now, or skip until HR is ready to offer employee advances.
      </div>

      <ReadinessSummary
        status={statuses.loans}
        loading={readinessLoading}
        onRefresh={refreshReadiness}
        items={[
          { label: "Loan categories", value: readiness.loans.categoryCount || 0 },
          { label: "Loan types", value: readiness.loans.typeCount || 0 },
        ]}
      />

      <Tabs
        className="onb-tabs"
        activeKey={activeTab}
        onChange={setActiveTab}
        items={items}
      />

      <div className="onb-foot">
        <PreviousButton onClick={onBack} text="Back" />
        <span className="spacer" />
        <Button onClick={skip}>Skip for now</Button>
        <NextButton onClick={continueStep} text="Continue" />
      </div>
    </>
  );
};

export default StepLoanSettings;
